import { Component } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { ReportTaskService } from "src/app/app/report/report-task/report-task.service";
import { ThisPlatform } from "src/app/_services/platform.service";

@Component({
  selector: "app-transfer-task",
  templateUrl: "./transfer-task.component.html",
  styleUrls: ["./transfer-task.component.scss"],
})
export class TransferTaskComponent {
  idUser: number;
  comment: string;

  constructor(
    private modalCtrl: ModalController,
    public translateServ: TranslateService,
    public reportTaskService: ReportTaskService,
    public p: ThisPlatform
  ) {}

  save() {
    this.modalCtrl.dismiss({ comment: this.comment });
  }

  back() {
    this.modalCtrl.dismiss();
  }
}
